import { render, staticRenderFns } from "./TAnswerContent.vue?vue&type=template&id=8749f590&"
import script from "./TAnswerContent.vue?vue&type=script&lang=js&"
export * from "./TAnswerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports